import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChemicalBlackeningSm = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 100 100",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "chemical-blackening-sm" }),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-white",
			d: "M8.56 61.43 49.87 37.58 91.44 61.58v4.32L50.13 89.75 8.56 65.75Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-outline",
			opacity: .24,
			d: "m50 39.04 39 22.54-38.87 22.47L50 61.5Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-outline",
			d: "M92.63,61.51a.73.73,0,0,0,0-.22l0-.07a1,1,0,0,0-.09-.21l0-.06a1.1,1.1,0,0,0-.14-.18l0-.05a1.13,1.13,0,0,0-.23-.17l-41.57-24a1.17,1.17,0,0,0-1.2,0L8,60.4a1.13,1.13,0,0,0-.23.17l-.05.06a1.09,1.09,0,0,0-.13.17l0,.06a1.89,1.89,0,0,0-.09.21v0a.69.69,0,0,0,0,.25v4.38a1.2,1.2,0,0,0,.6,1l41.57,24a1.21,1.21,0,0,0,1.2,0L92,66.94a1.2,1.2,0,0,0,.6-1V61.51ZM92,61.1Zm-43,25v1.54L9.76,65.06V63.51ZM89,61.58,50.13,84.05,11,61.43,49.87,39Zm1.2,2.08v1.55L51.33,87.67V86.13Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m58 49.1 21.5 12.4M54 55.9l17.6 10.2M54 65l9.7 5.6",
			fill: "none",
			stroke: "var(--icon-outline)",
			strokeWidth: 2.4,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-white",
			d: "M50 10.8c-2.2 4.7-12.1 14.7-12.1 21.4a12.1 12.1 0 0 0 24.2 0C62.1 25.5 52.2 15.5 50 10.8Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			fillRule: "evenodd",
			d: "M50 10.8c-2.2 4.7-12.1 14.7-12.1 21.4a12.1 12.1 0 0 0 24.2 0C62.1 25.5 52.2 15.5 50 10.8Zm0 4.6c-3.2 4.9-9.7 12.1-9.7 16.8a9.7 9.7 0 0 0 19.4 0c0-4.7-6.5-11.9-9.7-16.8Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M44.4 30.8a5.7 5.7 0 0 0 5.7 5.7",
			fill: "none",
			stroke: "var(--icon-highlight)",
			strokeWidth: 2.4,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "icon-highlight",
			x: 48.8,
			y: 47,
			width: 2.4,
			height: 3.8,
			rx: 1.2
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "icon-highlight",
			x: 48.8,
			y: 54.4,
			width: 2.4,
			height: 3.8,
			rx: 1.2
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "icon-highlight",
			x: 48.8,
			y: 61.8,
			width: 2.4,
			height: 3.8,
			rx: 1.2
		})
	]
});
export default SvgChemicalBlackeningSm;
